import { AppPagePlaceholder } from "./AppPagePlaceholder";

export function KeplerPage() {
  return <AppPagePlaceholder name="Kepler" />;
}
